import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {getter} from '@ibibo/client-side-storage';

import {IUpdate_Query, UPDATE_QUERY} from '../../common/redux/types';

import {addDays, defaultCheckinOffset, defaultCheckoutOffset} from '../../../utils/date-utils';
import {eventMiddlewareForFE} from '../../../utils/common-utils';
import {useNavigateForSearchWidget} from '../../../hooks/useNavigateForSearchWidget';

import RecentSearchUI from '../../../../stories/components/hotels/HomePage/RecentSearchUI/RecentSearchUI';

const RecentSearch = () => {
  const dispatch = useDispatch();

  let goHomeSearchesList = getter('go_home_searches');

  if (!goHomeSearchesList) return null;

  const [onSearch] = useNavigateForSearchWidget();

  const updateQueryCaller = useCallback((actionData: IUpdate_Query['actionData']) => {
    return dispatch({type: UPDATE_QUERY, actionData});
  }, []);

  return (
    <RecentSearchUI
      onSearch={onSearch}
      updateQueryCaller={updateQueryCaller}
      goHomeSearchesList={goHomeSearchesList}
      addDays={addDays}
      defaultCheckinOffset={defaultCheckinOffset}
      defaultCheckoutOffset={defaultCheckoutOffset}
      eventMiddlewareForFE={eventMiddlewareForFE}
    />
  );
};

export default RecentSearch;
